import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-sidenav-cell',
    templateUrl: './sidenav-cell.component.html',
    styleUrls: ['./sidenav-cell.component.scss']
})
export class SidenavCellComponent implements OnInit{

    @Input() item: any;
    @Input() isOpen: boolean;
    @Output() cellClick: EventEmitter<string> = new EventEmitter()
    @Output() subcellClick: EventEmitter<string> = new EventEmitter()

    public usePrefixedSidenav: boolean = environment.usePrefixedSidenav;

    ngOnInit(): void {
      if(this.item.expandable != undefined){
        this.item.expandable.forEach((subItem) => {
            if(subItem.id == localStorage.getItem('id_documento_registro')){
                this.sidenavClicked();
                this.subSidenavClicked(subItem.id);
            }
        })
    }
    }


    sidenavClicked() {
        this.cellClick.emit(this.item.id);
        this.isOpen = !this.isOpen;
        const firstItem = this.item.expandable[0]
        localStorage.setItem("id_documento_registro", firstItem.id);
    }

    subSidenavClicked(id: string) {
        this.subcellClick.emit(id);
        // console.log(id)
        localStorage.setItem("id_documento_registro", id);
    }

}
